import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ForgotPasswordForm from '../forms/ForgotPasswordForm';
import { FormBox, Wrapper } from '../styles';

const ForgotPasswordStep: React.FC = () => {
  return (
    <Wrapper container>
      <Grid item>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h2">
            <FormattedMessage id="forgotPassword.title" />
          </Typography>
          <Typography sx={{ mt: '16px', maxWidth: 456 }}>
            <FormattedMessage id="forgotPassword.pleaseEnterEmail.subtitle" />
          </Typography>
        </Box>
        <FormBox>
          <ForgotPasswordForm />
        </FormBox>
      </Grid>
    </Wrapper>
  );
};

export default ForgotPasswordStep;
